// TabSaveButton.js

import { useNavigate, useLocation } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import Button from '@mui/material/Button';
import { Herbaladr_SERVER } from '../../Config';
import { enqueueSnackbar } from 'notistack';
import { getParameter } from './../../utils/Utils';
import axios from 'axios';
axios.defaults.withCredentials = true;

export default function TabSaveButton({ fieldPaths, label = '저장', index }) {
  const { trigger, getValues } = useFormContext();
  const { state } = useLocation();
  const navigate = useNavigate();

  let axiosConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  const handleSave = async () => {
    const ok = await trigger(fieldPaths, { shouldFocus: true });
    if (!ok) return; // 유효성 실패 시
    const data = getValues();
    // 필요한 필드만 추출
    let payload = {};
    fieldPaths.forEach((path) => {
      // 중첩경로 처리
      const segments = path.split('.');
      let src = data,
        dst = payload;
      segments.forEach((seg, idx) => {
        if (idx === segments.length - 1) {
          dst[seg] = src?.[seg];
        } else {
          dst[seg] = dst[seg] || {};
          src = src?.[seg];
          dst = dst[seg];
        }
      });
    });
    // group ID 추가
    payload.groupId = getParameter('groupId');
    // objID 있으면 추가 - 신규 추가가아닌 update
    payload.objId = state ? state.objId : getParameter('objId');
    // console.log(`${index.tabIndex}:  ${label} payload:`, { ...payload });

    /* tabIndex
    0: '가. 환자 정보', content: <PatientInfoForm /> },
    1: '나. 이상사례∙약물이상반응 정보', content: <AdverseEventForm /> },
    2: '다. 의약품등 정보', content: <DrugInfoForm /> },
    3: '라. 보고 정보', content: <ReportInfoForm /> },
    4: '마. 종합의견', content: <FinalOpinionForm /> },
    */
    // let tabIndex = index.tabIndex;
    // if (tabIndex === 0) {
    //   //0: '가. 환자 정보'
    //   await axios.post(`${process.env.REACT_APP_SERVER}${Herbaladr_SERVER}`, payload, axiosConfig).then((res) => {
    //     res = res.data;
    //     if (res.success) {
    //       // console.log(res.doc);

    //       if (res.doc) {
    //         navigate({
    //           search: `?objId=${res.doc._id}&groupId=${getParameter('groupId')}`, // 쿼리 문자열 추가
    //         });
    //       }
    //       enqueueSnackbar('New Post Add Completed', {
    //         variant: 'success',
    //         autoHideDuration: 2500,
    //       });
    //     }
    //   });
    // } else if (tabIndex === 1) {
    //   //1: '나. 이상사례∙약물이상반응 정보'
    // } else if (tabIndex === 2) {
    //   //2: '다. 의약품등 정보'
    // } else if (tabIndex === 3) {
    //   //3: '라. 보고 정보'
    // } else if (tabIndex === 4) {
    //   //4: '마. 종합의견'
    // }

    await axios.post(`${process.env.REACT_APP_SERVER}${Herbaladr_SERVER}`, payload, axiosConfig).then((res) => {
      res = res.data;
      if (res.success) {
        // console.log(res.doc);

        if (res.doc) {
          navigate({
            search: `?objId=${res.doc._id}&groupId=${getParameter('groupId')}`, // 쿼리 문자열 추가
          });
        }
        enqueueSnackbar('New Post Add Completed', {
          variant: 'success',
          autoHideDuration: 2500,
        });
      }
    });
  };

  return (
    <Button variant="contained" onClick={handleSave}>
      {label}
    </Button>
  );
}
